"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Surface = void 0;

var _glReact = require("gl-react");

var _raf = _interopRequireDefault(require("raf"));

var _GLViewDOM = _interopRequireDefault(require("./GLViewDOM"));

require("webgltexture-loader-dom");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var RenderLessElement = "span";

var mapRenderableContent = function mapRenderableContent(el) {
  return el instanceof Element ? el.firstElementChild : null;
};

var Surface = (0, _glReact.createSurface)({
  GLView: _GLViewDOM["default"],
  RenderLessElement: RenderLessElement,
  mapRenderableContent: mapRenderableContent,
  requestFrame: _raf["default"],
  cancelFrame: _raf["default"].cancel
});
exports.Surface = Surface;